<div class="text-center text-md-start">
  <p class="mt-4">Download the app:</p>
  <div class="row gx-2">
    <!-- Google Play Store Button -->
    <div class="col-auto ms-auto ms-md-0">
      <a
        [href]="playStoreUrl"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Download Paystashio app on Google Play Store"
        (click)="onPlayStoreClick($event)">
        <img
          ngSrc="assets/btn-google-play.svg"
          alt=""
          height="40"
          width="114"
          priority />
      </a>
    </div>

    <!-- Apple App Store Button -->
    <div class="col-auto me-auto">
      <a
        [href]="appStoreUrl"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Download Paystashio app on Apple App Store"
        (click)="onAppStoreClick($event)">
        <img
          ngSrc="assets/btn-app-store.svg"
          alt=""
          height="40"
          width="114"
          priority />
      </a>
    </div>
  </div>
</div>
